// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LifeChangingEvents__LCETable___CgPyX {
    max-width: 500px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;    
}

.LifeChangingEvents__events___r394b {
    color: white;
    text-shadow: 0px 0px 10px gold;
}

.LifeChangingEvents__rating___Z7r0Z {
    text-shadow: 0px 0px 20px white;
    font-weight: bold;
    font-size: 20px;
    position: relative;
    top: 2px;
}

.LifeChangingEvents__year___p7AZj {
    font-size: 13px;
    opacity: 0.7;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"LCETable": `LifeChangingEvents__LCETable___CgPyX`,
	"events": `LifeChangingEvents__events___r394b`,
	"rating": `LifeChangingEvents__rating___Z7r0Z`,
	"year": `LifeChangingEvents__year___p7AZj`
};
module.exports = ___CSS_LOADER_EXPORT___;
